/*
 * 接口统一集成模块
 */
import * as login from './moudules/sys/login'
import * as user from './moudules/sys/user'
import * as dept from './moudules/sys/dept'
import * as role from './moudules/sys/role'
import * as menu from './moudules/sys/menu'
import * as dict from './moudules/sys/dict'
import * as info from './moudules/sys/info'
import * as infoType from './moudules/sys/infoType'
import * as infoMenu from './moudules/sys/infoMenu'
import * as log from './moudules/sys/log'
import * as privilege from './moudules/sys/privilege'
import * as attach from './moudules/sys/attach'
import * as sysTaskType from './moudules/sys/sysTaskType'
import * as sysTaskDeal from './moudules/sys/sysTaskDeal'
import * as personCenter from './moudules/sys/personCenter'
import * as sysParameter from './moudules/sys/sysParameter'
import * as commonPage from './moudules/sys/commonPage'
import * as sysAppVersion from './moudules/sys/sysAppVersion'

import * as Blob from '../vendor/Blob'
import * as Export2Excel from '../vendor/Export2Excel'

import * as homeData from './moudules/biz/home/homeData'
import * as home from './moudules/biz/home/home'
import * as commonJS from './moudules/commonJS/commonJS'

import * as project from './moudules/biz/basic/project'
import * as equipment from './moudules/biz/basic/equipment'
import * as location from './moudules/biz/basic/location'
import * as feeVehicle from './moudules/biz/basic/feeVehicle'
import * as feePerson from './moudules/biz/basic/feePerson'
import * as woAuditLog from './moudules/biz/workorder/woAuditLog'
import * as woInspection from './moudules/biz/workorder/woInspection'
import * as woRepair from './moudules/biz/workorder/woRepair'
import * as woRepairDaily from './moudules/biz/workorder/woRepairDaily'
import * as woRepairVehicle from './moudules/biz/workorder/woRepairVehicle'
import * as woDefect from './moudules/biz/workorder/woDefect'
import * as woInspectionDevice from './moudules/biz/workorder/woInspectionDevice'

import * as yearlyPlan from './moudules/biz/plan/yearlyPlan'
import * as monthlyPlan from './moudules/biz/plan/monthlyPlan'
import * as weeklyPlan from './moudules/biz/plan/weeklyPlan'

import * as confirmDefect from './moudules/biz/confirm/confirmDefect'
import * as confirmInspection from './moudules/biz/confirm/confirmInspection'

import * as statWoRepair from './moudules/biz/stat/statWoRepair'
import * as statWoDefect from './moudules/biz/stat/statWoDefect'
import * as statYear from './moudules/biz/stat/statYear'
import * as statOrderUse from './moudules/biz/stat/statOrderUse'



// 默认全部导出
export default {
  login,
  user,
  dept,
  role,
  menu,
  dict,
  info,
  infoType,
  infoMenu,
  log,
  privilege,
  sysTaskType,
  sysTaskDeal,
  attach,
  personCenter,
  sysParameter,
  commonPage,
  Blob,
  Export2Excel,
  homeData,
  home,
  commonJS,
  sysAppVersion,
  project,
  equipment,
  location,
  feeVehicle,
  feePerson,
  woAuditLog,
  woInspection,
  woRepair,
  woRepairDaily,
  woRepairVehicle,
  woDefect,
  woInspectionDevice,

  yearlyPlan,
  monthlyPlan,
  weeklyPlan,
  confirmDefect,
  confirmInspection,

  statWoRepair,
  statWoDefect,
  statYear,
  statOrderUse
}



// WEBPACK FOOTER //
// ./src/http/api.js